import { Dispatch  } from 'redux';
import { ISmartSheetInfo } from '../../interface/interface';
class SmartSheet{

setIsSmartSheetLoaded = (status:boolean)=>{
    return (dispatch:Dispatch<any>)=>{
        return new Promise<void>((resolve, reject) => {
        dispatch({
            type:'SET_IS_SMARTSHEET_LOADED',
            payload: status
        })
        resolve()
    });
    }
 }

 setSmartSheetInfo = (info:ISmartSheetInfo)=>{
    return (dispatch:Dispatch<any>)=>{
        return new Promise<void>((resolve, reject) => {
        dispatch({
            type:'SET_SMARTSHEET_INFO',
            payload: info
        })
        resolve()
    });
    }
 }

}

export const smartSheetActions = new SmartSheet();